import { apiClientWithRefreshToken } from "@/api/apiClient";
import { WorkLogs } from "./FindOneTimeSheetLog";

export default async function UpdateTimeSheetLog({
    cellId,
    status,
    hours = 0,
}: {
    cellId: string;
    status: WorkLogs["status"];
    hours: number;
}): Promise<{
    cellId: string;
    status: WorkLogs["status"];
    hours: number;
}> {
    await apiClientWithRefreshToken({
        url: `/time-sheets/logs/${cellId}`,
        method: "PUT",
        data: {
            hours: hours,
            status: status,
        },
    });

    return {
        cellId,
        status,
        hours,
    };

    // return res.data;
}
